import { monthIndexToMonth } from 'api/recommendations'
import moment from 'moment'
import type { IntlShape } from 'react-intl'
import {
  INTL_DAY_MONTH_NAME_SHORT,
  INTL_LONG_MONTH,
} from 'constants/dateFormats'
import { intlDateFormatter } from 'lib/datetime/dateUtils'

interface Props {
  checkIn?: string
  monthIndex?: string
  duration: number
  intl: IntlShape
}

export function getRecommendationsTitle({
  checkIn,
  monthIndex,
  duration,
  intl,
}: Props): { title: string } {
  if (checkIn) {
    const checkInMoment = moment(checkIn)
    const checkOutMoment = checkInMoment.clone().add(duration, 'days')
    const from = intlDateFormatter(checkInMoment, INTL_DAY_MONTH_NAME_SHORT, intl.locale)
    const to = intlDateFormatter(checkOutMoment, INTL_DAY_MONTH_NAME_SHORT, intl.locale)
    return {
      title: intl.formatMessage(
        {
          id: 'BDo_HvqWNF6mWHJNYS-n',
          defaultMessage: 'Similar hotels available {from} - {to}',
          description: 'Calendar recommendations heading showing the selected check-in and check-out date range',
        },
        { from, to },
      ),
    }
  }
  if (monthIndex) {
    return {
      title: intl.formatMessage(
        {
          id: '0xvjGH42P12hbqU-tese',
          defaultMessage: 'Similar hotels available in {month}',
          description: 'Calendar recommendations heading showing the selected availability month',
        },
        { month: intlDateFormatter(moment(monthIndexToMonth(monthIndex), 'M-YYYY'), INTL_LONG_MONTH, intl.locale) },
      ),
    }
  }
  return {
    title: intl.formatMessage({
      id: 'yZVrJXvg-FKIGgLLrner',
      defaultMessage: 'Similar hotels',
      description: 'Default calendar recommendations heading when no availability period is selected',
    }),
  }
}
